module.exports = __webpack_public_path__ + "img/canvasMenu1.7e44df85.svg";